import { Controller } from '@hotwired/stimulus'
import { CreatedEvent, NoteData } from './finfolio-note'

export default class FinfolioNoteListController extends Controller<HTMLElement> {
  declare readonly itemTemplateTarget: HTMLTemplateElement
  declare readonly listTarget: HTMLUListElement

  static targets = ['itemTemplate', 'list']

  now = new Date()

  // Public methods

  addNote(event: CreatedEvent) {
    const { note } = event.detail
    const itemHtml = this.#generateItemHtml(note)
    const optionToSelect = itemHtml.querySelector<HTMLOptionElement>(`option[value="${note.categoryId}"]`)

    optionToSelect.selected = true

    this.listTarget.append(itemHtml)
  }

  // Private methods

  #generateItemHtml(note: NoteData) {
    const templateCopy = document.createElement('template')

    templateCopy.innerHTML = this.itemTemplateTarget.innerHTML
      .replaceAll('{{category}}', note.category)
      .replaceAll('{{categoryId}}', note.categoryId)
      .replaceAll('{{createdDate}}', this.#today())
      .replaceAll('{{createdDateDatetime}}', this.now.toISOString())
      .replaceAll('{{description}}', note.description)
      .replaceAll('{{id}}', note.id)

    return templateCopy.content
  }

  #today() {
    return new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric' }).format(this.now)
  }
}
